<template>
  <div>
      <FormCompleted/>
  </div>
</template>

<script>

import FormCompleted from "@/components/DataComponents/Forms/FormCompletedPage.vue";

export default {
  name: "form-completed-page-view",
  components: {FormCompleted},
  title: 'FormCompletedPage',
};
</script>